import { render } from "./bulletPointsBlock.vue?vue&type=template&id=1b5bf72b&ts=true"
import script from "./bulletPointsBlock.vue?vue&type=script&lang=ts"
export * from "./bulletPointsBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__